<div class="form-page">
    <div class="steps-grafic">
        <app-registry-steps-grafic></app-registry-steps-grafic>
    </div>
    <div class="text-container-right">
        <app-product-screen class="right-container-width min-height"></app-product-screen>
    </div>
</div>